import { Component } from "@angular/core";

@Component({
    selector: "app-tickets",
    templateUrl: "./tickets.page.html",
    styleUrls: ["./tickets.page.scss"]
})
export class TicketsPage {}
